module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-card-title', [_c('h4', [_vm._v("Customer")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.customer), function(value, key) {
    return _c('v-list-item', {
      key: key
    }, [_c('v-list-item-content', [_vm._v(_vm._s(key) + ":")]), _vm._v(" "), _c('v-list-item-content', {
      staticClass: "align-end"
    }, [_c('input', {
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": value
      }
    })])], 1)
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-48aa6bb7"}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/returnShopPortals/Get.vue
// module id = 934
// module chunks = 1